
import { mapActions, mapGetters } from 'vuex'
import { clone } from '../../utils/enerFunctions'
import { capitalize } from '@/utils/StringUtils'

export default {
  name: 'BenchmarkBuilder',
  computed: {
    ...mapGetters({
      countries: 'countries',
      benchmarkCountries: 'page/benchmarkCountries'
    }),
    sortedCountries () {
      const orderedCountries = clone(this.countries)
      return orderedCountries.sort((a, b) => (a[this.textField] > b[this.textField]) ? 1 : ((b[this.textField] > a[this.textField]) ? -1 : 0))
    },
    textField () {
      return 'name' + capitalize(this.$i18n.locale)
    }
  },
  methods: {
    ...mapActions({
      setBenchmarkCountries: 'page/setBenchmarkCountries',
      clearBenchmarkCountries: 'page/clearBenchmarkCountries',
      removeBenchmarkCountry: 'page/removeBenchmarkCountry'
    })
  }
}
